import dayjs from 'dayjs';
import { WorkOrder } from '@models';
import { CalendarDimensions } from '@enums';
import { CalendarSettingsType } from '../calendar-types';

export function getTaskBoundaries(
  currentDayUnix: number,
  settings: CalendarSettingsType,
  workOrder: WorkOrder
) {
  let workOrderStart;
  let workOrderEnd;

  const dimmensionStartTime = dayjs
    .unix(currentDayUnix)
    .add(settings.startingHour, 'hour');
  const dimmensionEndTime = dayjs
    .unix(currentDayUnix)
    .add(1, CalendarDimensions.DAY)
    .subtract(24 - settings.endingHour, 'hour');

  workOrderStart = dayjs(workOrder.startTime);
  workOrderEnd = dayjs(workOrder.endTime);

  // if task starts before the dimension interval starts
  if (workOrderStart.isBefore(dimmensionStartTime)) {
    workOrderStart = dimmensionStartTime;

    const diff = dimmensionStartTime.diff(workOrderStart, 'second');
    workOrderEnd = workOrderEnd.subtract(diff, 'second');
  }

  // if task ends after the dimension interval ends
  if (workOrderEnd.isAfter(dimmensionEndTime)) {
    workOrderEnd = dimmensionEndTime;
  }

  return {
    workOrderStart,
    workOrderEnd,
  };
}
